import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { classNames } from '../../utils';
import { DateTime } from 'luxon';
import ChevronLeft from '../../icons/ChevronLeft';
import ChevronRight from '../../icons/ChevronRight';
import Button from '../Button';
import styles from './YearPicker.module.css';
const range = (start, end) => {
    return Array(end - start + 1)
        .fill(0)
        .map((_, idx) => start + idx);
};
const createYearList = (year) => {
    const zodiacStartYear = Math.floor(year / 12) * 12 + 1;
    const zodiacEndYear = zodiacStartYear + 11;
    return range(zodiacStartYear, zodiacEndYear);
};
const years = createYearList(new Date().getFullYear());
const YearPicker = ({ selectedYear, setSelectedYear, disableFuture, disableBefore, disableAfter, ianaTimeZoneCode, }) => {
    const now = DateTime.fromJSDate(new Date()).setZone(ianaTimeZoneCode);
    const currentYear = now.year;
    const isCurrentYearSelected = currentYear === selectedYear;
    const before = disableBefore === null || disableBefore === void 0 ? void 0 : disableBefore.split('-');
    const yearJustBefore = Number(before === null || before === void 0 ? void 0 : before[0]);
    const monthJustBefore = Number(before === null || before === void 0 ? void 0 : before[1]);
    const dayJustBefore = Number(before === null || before === void 0 ? void 0 : before[2]);
    const after = disableAfter === null || disableAfter === void 0 ? void 0 : disableAfter.split('-');
    const yearJustAfter = Number(after === null || after === void 0 ? void 0 : after[0]);
    const monthJustAfter = Number(after === null || after === void 0 ? void 0 : after[1]);
    const dayJustAfter = Number(after === null || after === void 0 ? void 0 : after[2]);
    const [pageIndex, setPageIndex] = useState(Math.floor(currentYear / 12));
    const [years, setYears] = useState(createYearList(new Date().getFullYear()));
    const isYearBefore = useCallback((year) => yearJustBefore > year, [yearJustBefore]);
    const isYearAfter = useCallback((year) => yearJustAfter < year, [yearJustAfter]);
    useEffect(() => {
        setYears(createYearList(pageIndex * 12));
    }, [pageIndex]);
    useEffect(() => {
        if (!disableFuture || !isCurrentYearSelected)
            return;
        if (selectedYear > currentYear)
            setSelectedYear(currentYear);
    }, [
        isCurrentYearSelected,
        currentYear,
        selectedYear,
        setSelectedYear,
        disableFuture,
    ]);
    return (_jsxs("div", Object.assign({ className: styles.root }, { children: [_jsxs("div", Object.assign({ className: styles.yearNav }, { children: [_jsx("div", Object.assign({ className: styles.navButtonWrapper }, { children: _jsx(Button, Object.assign({ variant: "text", disabled: isYearBefore(years[0] - 1), onClick: () => setPageIndex(pageIndex - 1) }, { children: _jsx("span", Object.assign({ className: styles.navButtonColor }, { children: _jsx(ChevronLeft, { variant: "tiny", size: 20 }, void 0) }), void 0) }), void 0) }), void 0), _jsx("div", { children: `${years[0]} - ${years[years.length - 1]}` }, void 0), _jsx("div", Object.assign({ className: styles.navButtonWrapper }, { children: _jsx(Button, Object.assign({ variant: "text", disabled: isYearAfter(years[years.length - 1] + 1), onClick: () => setPageIndex(pageIndex + 1) }, { children: _jsx("span", Object.assign({ className: styles.navButtonColor }, { children: _jsx(ChevronRight, { variant: "tiny", size: 20 }, void 0) }), void 0) }), void 0) }), void 0)] }), void 0), _jsx("div", Object.assign({ className: styles.monthSelect }, { children: years.map((year, index) => {
                    const disabled = year > now.year
                        ? isYearAfter(year) || disableFuture
                        : isYearBefore(year) || isYearAfter(year);
                    return (_jsx(Button, Object.assign({ variant: "text", className: styles.monthButton, onClick: () => setSelectedYear(year), disabled: disabled }, { children: _jsx("div", Object.assign({ className: classNames(styles.monthLabel, Number(selectedYear) === year
                                ? styles.selectedMonth
                                : undefined, disabled ? styles.disabled : undefined) }, { children: year }), void 0) }), `yearSelect${index}`));
                }) }), void 0)] }), void 0));
};
export default YearPicker;
